import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای پالت‌های فعال ایستگاه (Lot Feed Sessions)

این بخش برای مدیریت سشن‌های تغذیه قطعات و کنترل جریان ورود مواد اولیه یا نیمه‌ساخته‌ها (پالت‌ها) به یک ایستگاه مشخص طراحی شده است. به کمک این فرم، سیستم ردیابی متوجه می‌شود قطعات فعلی در حال تولید، دقیقاً از کدام پالت‌ها مصرف می‌شوند.

## ۱. انتخاب ایستگاه کاری
در ابتدا، از لیست کشویی **شناسهٔ ایستگاه (WorkCenter)**، ایستگاه کاری مدنظر خود را از میان گزینه‌های موجود انتخاب کنید. با انتخاب ایستگاه، امکان وارد کردن یا اسکن پالت‌ها برای آن ایستگاه فعال خواهد شد.

## ۲. اسکن یا تایپ شماره پالت
برای باز کردن و ثبت جریان مصرف از یک پالت جدید، به راحتی **شماره پالت (Lot Number)** را در کادر مربوطه اسکن کرده یا به صورت دستی تایپ نموده و سپس کلید Enter یا ثبت را بزنید.
نیازی به وارد کردن شناسه سیستمی پالت نیست؛ سیستم با گرفتن شماره خوانای پالت، آن را به درستی شناسایی و ثبت می‌کند.

<Alert type="info">
**چند پالت همزمان:** 
یک ایستگاه ممکن است به‌طور همزمان از چند پالت مختلف تغذیه شود. با اسکن پالت‌های جدید، همه آن‌ها در قسمت «سشن‌های باز» لیست خواهند شد.
</Alert>

## ۳. مدیریت سشن‌های باز
در بخش پایینی صفحه با عنوان «سشن‌های باز»، می‌توانید لیست تمام پالت‌هایی که هم‌اکنون به این ایستگاه متصل و فعال هستند را مشاهده کنید. برای هر پالت، زمان دقیق شروع سشن نیز نمایش داده می‌شود.

## ۴. بستن سشن
هنگامی که محتویات یک پالت تمام شد یا دیگر در این ایستگاه مورد استفاده قرار نمی‌گیرد، باید دکمه **بستن سشن** که روبروی همان پالت در لیست قرار دارد را کلیک کنید تا سشن تغذیه پایان یافته و سیستم متوجه اتمام مصرف از آن پالت در این ایستگاه بشود.

<Alert type="warning">
**توجه به خطاهای سیستم:**
اگر پالتی با شماره وارد شده پیدا نشود یا آن پالت همین الان روی ایستگاه باز باشد، سیستم هشدار متناسب با خطا را جهت راهنمایی دقیق‌تر به شما نمایش می‌دهد.
</Alert>

export default Layout;
